import * as React from "react";

import { useStoreState } from "../store";
import Modal from "../components/common/Modal";
import Button from "../components/common/PressableButton";
import Text from "../components/common/Text";
import DebugButton from "../components/common/DebugButton";

import useAuthorizeWithParams, { oAuth2Client } from "./useAuthorizeWithParams";
import useUnauthorizeOnError from "./useUnauthorizeOnError";

function AuthProvider({ children }: React.PropsWithChildren<{}>) {
  const authorizeUrl = React.useMemo(
    () =>
      oAuth2Client.generateAuthUrl({
        access_type: "offline",
        scope: "https://www.googleapis.com/auth/userinfo.profile",
      }),
    []
  );

  useAuthorizeWithParams();
  useUnauthorizeOnError();

  const authorized = useStoreState((state) => state.auth.authorized);

  return (
    <>
      {!authorized && (
        <Modal
          title="Welcome to mnUvr!"
          isDismissable={false}
          isVisible
          content={<Text.Paragraph>Please login to continue</Text.Paragraph>}
          primaryAction={
            <Button
              title="Login with Google"
              disabled={authorized}
              onPress={() => window.location.assign(authorizeUrl)}
              mode="contained"
            />
          }
          // secondaryAction={<DebugButton />}
        />
      )}

      {children}
    </>
  );
}

export default AuthProvider;
